import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';
import { PendingAuthorization } from '.';
import {
    IAuthorizationClass,
    IAuthorizationType,
    IDirectReport,
    IServiceItem,
    ITask
} from '../../lookups';
import { UserAuthorization } from './user-authorization.model';

export const loadUserAuthorizations = createAction(
    '[UserAuthorization/API] Load UserAuthorizations',
    props<{ userAuthorizations: UserAuthorization[] }>()
);

export const addUserAuthorization = createAction(
    '[UserAuthorization/API] Add UserAuthorization',
    props<{ userAuthorization: UserAuthorization }>()
);

export const upsertUserAuthorization = createAction(
    '[UserAuthorization/API] Upsert UserAuthorization',
    props<{ userAuthorization: UserAuthorization }>()
);

export const addUserAuthorizations = createAction(
    '[UserAuthorization/API] Add UserAuthorizations',
    props<{ userAuthorizations: UserAuthorization[] }>()
);

export const upsertUserAuthorizations = createAction(
    '[UserAuthorization/API] Upsert UserAuthorizations',
    props<{ userAuthorizations: UserAuthorization[] }>()
);

export const updateUserAuthorization = createAction(
    '[UserAuthorization/API] Update UserAuthorization',
    props<{ userAuthorization: Update<UserAuthorization> }>()
);

export const updateUserAuthorizations = createAction(
    '[UserAuthorization/API] Update UserAuthorizations',
    props<{ userAuthorizations: Update<UserAuthorization>[] }>()
);

export const deleteUserAuthorization = createAction(
    '[UserAuthorization/API] Delete UserAuthorization',
    props<{ id: number }>()
);

export const deleteUserAuthorizations = createAction(
    '[UserAuthorization/API] Delete UserAuthorizations',
    props<{ ids: number[] }>()
);

export const clearUserAuthorizations = createAction(
    '[UserAuthorization/API] Clear UserAuthorizations'
);
export const getUserAuthorizations = createAction(
    '[UserAuthorization/API] Get UserAuthorizations',
    props<{
        endDate?: Date;
        endDateOperator?: string;
        directReports?: Array<IDirectReport>;
        tasks?: Array<ITask>;
        serviceItems?: Array<IServiceItem>;
        classes?: Array<IAuthorizationClass>;
        authTypes?: Array<IAuthorizationType>;
        modifiedDate?: Date;
        AddAuthAction?: boolean;
        AddAuthMode?: boolean;
        showSI?: boolean;
        showPI?: boolean;
    }>()
);
export const putUserAuthorzations = createAction(
    '[UserAuthorization/API] Put UserAuthorizations',
    props<{ authorizations: UserAuthorization[] }>()
);
export const removeUserAuthorizations = createAction(
    '[UserAuthorization/API] Remove UserAuthorizations',
    props<{ ids: number[] }>()
);
export const getPendingUserAuthorizationsCount = createAction(
    '[UserAuthorization/API] getPendingUserAuthorizationCount'
);
export const loadPendingUserAuthorizationsCount = createAction(
    '[UserAuthorization/API] loadPendingUserAuthorizationCount',
    props<{ count: number }>()
);
export const getPendingUserAuthorizations = createAction(
    '[UserAuthorization/API] getPendingUserAuthorization'
);
export const loadPendingUserAuthorizations = createAction(
    '[UserAuthorization/API] loadPendingUserAuthorizations',
    props<{ auths: PendingAuthorization[] }>()
);
export const addPendingUserAuthorizations = createAction(
    '[UserAuthorization/API] addPendingUserAuthorizations',
    props<{
        endDate: Date;
        endDateOperator: string;
        directReports: Array<Partial<IDirectReport>>;
        tasks: Array<Partial<ITask>>;
        serviceItems: Array<Partial<IServiceItem>>;
        classes: Array<Partial<IAuthorizationClass>>;
        authTypes: Array<Partial<IAuthorizationType>>;
        modifiedDate: Date;
        AddAuthMode?: boolean;
        AddAuthAction?: boolean;
        showSI?: boolean;
        EmployeeAuthStartDate?: Date;
        EmployeeAuthEndDate?: Date;
    }>()
);
